import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../Includes/Navbar";
import carousel1 from "../Images/img/harm-reduction.png";
import carousel2 from "../Images/img/carousel-1.png";
import carousel3 from "../Images/img/carousel-2.jpg";
import aboutImage from "../Images/img/about.jpg";
import team1 from "../Images/img/team-1.png";
import team2 from "../Images/img/team-2.png";
import team3 from "../Images/img/team-3.png";
import team4 from "../Images/img/team-4.png";
import team5 from "../Images/img/team-5.png";
import bannerImg from "../Images/bnnerImg.png";
import Footer from "../Includes/Footer";
import GeneralService from "../../services/general.service";
import { useFormik } from "formik";
import * as Yup from "yup";
import "./Home.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import azmText from "../Images/azm-text.png";
import Appointment from "../Appointment/Appointment";
import Seo from "../SEO/Seo";
import { buildLocalBusinessSchema, buildWebsiteSchema } from "../../seo/schema";

const signUpSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
});

export default function Home(doctor) {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    resetForm,
  } = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: signUpSchema,
    onSubmit: async (values, actions) => {
      try {
        const response = await GeneralService.signUp(values);
        console.log("API response:", response);
        toast.success("Subscribe successful!"); // Show success toast message
        resetForm();
        scrollToTop(); // Scroll to top after successful sign-up
      } catch (error) {
        console.error("API error:", error);
        toast.error("Subscribe failed. Please try again."); // Show error toast message
      } finally {
        actions.setSubmitting(false);
      }
    },
  });

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" }); // Smooth scroll to top
  };

  const location = useLocation();

  // Scroll to top on mount, unless arriving via the navbar's "Book
  // Appointment" link from another page, in which case jump to the form.
  useEffect(() => {
    if (location.hash === "#appointment-form") {
      const timer = setTimeout(() => {
        document.getElementById("appointment-form")?.scrollIntoView({ behavior: "smooth" });
      }, 300);
      return () => clearTimeout(timer);
    }
    scrollToTop();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [doctors, setDoctors] = useState([]);

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const data = await GeneralService.getDoctors();
        setDoctors(data);
      } catch (error) {
        console.error(error.message);
      }
    };
    fetchDoctors();
  }, []);

  const getImageSource = (doctor) => {
    // If doctor has an image, use it
    if (doctor.image) {
      return doctor.image.startsWith('http')
        ? doctor.image
        : `https://azmrehabcentre.pk/api/public/${doctor.image.replace(/^\/+/, '')}`;
    }

    // If no image, check gender and return appropriate default
    // Assuming doctor has a gender field, or we infer from name/other data
    return doctor.gender === 'female' ? team4 : team5;
  };

  // Opening Hours State - similar to Navbar
  const [openingHours, setOpeningHours] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [hoursData, setHoursData] = useState(null);

  // Fetch opening hours - same logic as Navbar
  useEffect(() => {
    const fetchOpeningHours = async () => {
      setLoading(true);
      setError(null);
      try {
        console.log('Fetching opening hours from API...');
        const response = await GeneralService.getOpeningHours();

        console.log('API Response:', response);
        console.log('Response success:', response?.success);
        console.log('Response data:', response?.data);

        let hoursData = [];

        // Check if response has the expected structure
        if (response && response.success && response.data) {
          console.log('API data length:', response.data.length);
          console.log('API data structure:', response.data);

          if (Array.isArray(response.data) && response.data.length > 0) {
            hoursData = response.data;
            console.log("Using response.data:", hoursData);
          } else {
            console.warn('API returned empty or invalid data array');
            // Set fallback data
            hoursData = [
              {
                day_range: 'Monday - Sunday',
                formatted_time: '9.00 am - 10.00 pm',
                is_closed: false,
                emergency_only: false,
                open_time: '09:00:00',
                close_time: '22:00:00'
              }
            ];
          }
        } else if (Array.isArray(response)) {
          hoursData = response;
          console.log("Using direct response array:", hoursData);
        } else {
          console.error("API response is not in expected format:", response);
          // Set fallback data
          hoursData = [
            {
              day_range: 'Monday - Sunday',
              formatted_time: '9.00 am - 10.00 pm',
              is_closed: false,
              emergency_only: false,
              open_time: '09:00:00',
              close_time: '22:00:00'
            }
          ];
        }

        // Store raw API data for status checking
        setHoursData(hoursData);

        // Process the API format with day_range and formatted_time
        const formattedHours = hoursData.map(item => {
          // Handle your API format
          if (item.day_range && item.formatted_time) {
            return {
              day_range: item.day_range,
              formatted_time: item.formatted_time,
              is_closed: item.is_closed || false,
              emergency_only: item.emergency_only || false,
              open_time: item.open_time,
              close_time: item.close_time
            };
          }

          // Fallback for old format (backward compatibility)
          return {
            ...item,
            day: item.day || item.dayName || 'Unknown Day',
            open_time: item.open_time || item.openTime || item.start_time,
            close_time: item.close_time || item.closeTime || item.end_time,
            is_closed: item.is_closed || item.isClosed || item.closed || false
          };
        });

        setOpeningHours(formattedHours);
        console.log("Opening hours set:", formattedHours);

      } catch (err) {
        console.error("Error fetching opening hours:", err);
        setError("Failed to fetch opening hours. Please try again later.");

        // Fallback to match your API format
        const fallbackData = [
          {
            day_range: 'Monday - Sunday',
            formatted_time: '9.00 am - 10.00 pm',
            is_closed: false,
            emergency_only: false,
            open_time: '09:00:00',
            close_time: '22:00:00'
          }
        ];

        setOpeningHours(fallbackData);
        setHoursData(fallbackData);
      } finally {
        setLoading(false);
      }
    };

    fetchOpeningHours();
  }, []);

  // Check if open - same logic as Navbar
  useEffect(() => {
    if (hoursData) {
      checkIfOpen();
      // Check every minute
      const interval = setInterval(checkIfOpen, 60000);
      return () => clearInterval(interval);
    }
  }, [hoursData]);

const checkIfOpen = () => {
  const now = new Date();
  const currentDay = now.toLocaleDateString('en-US', { weekday: 'long' });
  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();
  const currentTime = currentHour * 60 + currentMinute;
  
  console.log('=== CHECKING IF OPEN ===');
  console.log('Current Day:', currentDay);
  console.log('Current Time:', `${currentHour}:${currentMinute.toString().padStart(2, '0')}`);
  console.log('Current Time in Minutes:', currentTime);
  
  // If we have API data, use it
  if (hoursData && Array.isArray(hoursData)) {
    let todaySchedule = null;
    
    // Find today's schedule
    for (const schedule of hoursData) {
      if (schedule.day_range) {
        const days = parseDayRange(schedule.day_range);
        if (days.includes(currentDay)) {
          todaySchedule = schedule;
          break;
        }
      } else if (schedule.day && schedule.day === currentDay) {
        todaySchedule = schedule;
        break;
      }
    }
    
    console.log('Today\'s Schedule Found:', todaySchedule);
    
    if (todaySchedule) {
      if (todaySchedule.is_closed) {
        console.log('❌ CLOSED: Schedule says closed today');
        setIsOpen(false);
        return;
      }
      
      if (todaySchedule.open_time && todaySchedule.close_time) {
        const openTime = timeToMinutes(todaySchedule.open_time);
        const closeTime = timeToMinutes(todaySchedule.close_time);
        
        console.log('Open Time (API):', todaySchedule.open_time, '→', openTime, 'minutes');
        console.log('Close Time (API):', todaySchedule.close_time, '→', closeTime, 'minutes');
        
        // CRITICAL FIX: Business closes EXACTLY at close time
        const isCurrentlyOpen = currentTime >= openTime && currentTime < closeTime;
        
        console.log('Time Check:');
        console.log(`  Current: ${currentTime} minutes`);
        console.log(`  Open: ${openTime} minutes`);
        console.log(`  Close: ${closeTime} minutes`);
        console.log(`  Is Open: ${isCurrentlyOpen}`);
        console.log(`  Logic: ${currentTime} >= ${openTime} && ${currentTime} < ${closeTime}`);
        
        if (isCurrentlyOpen) {
          console.log('✅ OPEN NOW');
        } else {
          console.log('❌ CLOSED NOW');
        }
        
        setIsOpen(isCurrentlyOpen);
        return;
      }
    }
  }
  
  // Fallback to default hours
  console.log('⚠️ Using fallback hours');
  const openTime = 9 * 60; // 9:00 AM
  const closeTime = 22 * 60; // 10:00 PM
  
  setIsOpen(currentTime >= openTime && currentTime < closeTime);
};

  // Helper function to convert time string to minutes
const timeToMinutes = (timeString) => {
  if (!timeString || typeof timeString !== 'string') {
    console.warn('Invalid time string:', timeString);
    return 0;
  }
  
  try {
    const parts = timeString.split(':');
    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1] || '0', 10);
    const totalMinutes = hours * 60 + minutes;
    
    console.log(`Time Conversion: ${timeString} → ${hours}h ${minutes}m = ${totalMinutes} minutes`);
    return totalMinutes;
  } catch (error) {
    console.error('Error parsing time:', error);
    return 0;
  }
};

  // Helper function to parse day ranges like "Monday - Friday" or "Monday, Wednesday"
  const parseDayRange = (dayRange) => {
    if (!dayRange) return [];

    const dayOrder = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    // Handle single day
    if (!dayRange.includes('-') && !dayRange.includes(',')) {
      return [dayRange.trim()];
    }

    // Handle comma-separated days
    if (dayRange.includes(',') && !dayRange.includes('-')) {
      return dayRange.split(',').map(day => day.trim());
    }

    // Handle day ranges like "Monday - Friday"
    if (dayRange.includes('-')) {
      const parts = dayRange.split('-').map(part => part.trim());
      if (parts.length === 2) {
        const startIndex = dayOrder.indexOf(parts[0]);
        const endIndex = dayOrder.indexOf(parts[1]);

        if (startIndex !== -1 && endIndex !== -1) {
          const days = [];
          for (let i = startIndex; i <= endIndex; i++) {
            days.push(dayOrder[i]);
          }
          return days;
        }
      }
    }

    return [];
  };

  // Use the same formatting logic as Navbar
  const formatTime = (time) => {
    if (!time || typeof time !== 'string') {
      console.warn('Invalid time format:', time);
      return 'Invalid Time';
    }

    try {
      // Handle both HH:MM and HH:MM:SS formats
      const timeParts = time.split(':');
      const hours = timeParts[0];
      const minutes = timeParts[1] || '00';

      const hourNum = parseInt(hours, 10);
      const hour12 = hourNum % 12 || 12;
      const ampm = hourNum >= 12 ? 'pm' : 'am';
      return `${hour12}.${minutes.padStart(2, '0')} ${ampm}`;
    } catch (error) {
      console.error('Error formatting time:', error);
      return 'Invalid Time';
    }
  };

  // Function to group days with same timings - enhanced version
  const groupOpeningHours = (openingHours) => {
    if (!Array.isArray(openingHours) || openingHours.length === 0) {
      return [];
    }

    console.log('Grouping opening hours:', openingHours);

    // Handle the new API format with day_range
    if (openingHours.length > 0 && openingHours[0].day_range) {
      return openingHours.map(item => {
        let displayTime;

        if (item.is_closed) {
          displayTime = item.emergency_only ? 'Closed (Emergency Only)' : 'Closed';
        } else if (item.formatted_time) {
          displayTime = item.formatted_time;
        } else if (item.open_time && item.close_time) {
          displayTime = `${formatTime(item.open_time)} - ${formatTime(item.close_time)}`;
        } else {
          displayTime = 'Hours not available';
        }

        return {
          days: item.day_range,
          time: displayTime,
          is_closed: item.is_closed || false,
          emergency_only: item.emergency_only || false
        };
      });
    }

    // Handle old format - group by time
    const timeGroups = {};

    openingHours.forEach(item => {
      let timeKey;

      if (item.is_closed || item.time === 'Closed') {
        timeKey = 'CLOSED';
      } else if (item.time) {
        timeKey = item.time;
      } else if (item.formatted_time) {
        timeKey = item.formatted_time;
      } else {
        timeKey = `${formatTime(item.open_time)} - ${formatTime(item.close_time)}`;
      }

      if (!timeGroups[timeKey]) {
        timeGroups[timeKey] = [];
      }

      // Get short day name (Mon, Tue, etc.)
      const shortDay = item.day ? item.day.substring(0, 3) : 'Day';
      timeGroups[timeKey].push(shortDay);
    });

    // Convert groups to display format
    return Object.entries(timeGroups).map(([time, days]) => ({
      days: days.join(', '),
      time: time === 'CLOSED' ? 'Closed' : time,
      is_closed: time === 'CLOSED'
    }));
  };

  return (
    <>
      <Seo
        title="Azm Rehab Centre | Drug Addiction & Rehabilitation Treatment Center, Sargodha"
        description="Azm Rehab Centre is a trusted drug addiction treatment and rehabilitation center in Sargodha, Punjab. Expert nasha treatment, psychological care and recovery programs for ice, heroin, alcohol and other substance abuse."
        path="/"
        jsonLd={[buildLocalBusinessSchema(), buildWebsiteSchema()]}
      />
      <Navbar />

      {/* <!-- Full Screen Search Start --> */}
      <div className="modal fade" id="searchModal" tabIndex="-1">
        <div className="modal-dialog modal-fullscreen">
          <div
            className="modal-content"
            style={{ background: "rgba(9, 30, 62, .7)" }}
          >
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn bg-white btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body d-flex align-items-center justify-content-center">
              <div className="input-group" style={{ maxWidth: "600px" }}>
                <input
                  type="text"
                  className="form-control bg-transparent border-primary p-3"
                  placeholder="Type search keyword"
                />
                <button className="btn btn-primary px-4">
                  <i className="bi bi-search"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Full Screen Search End --> */}

      {/* <!-- Carousel Start --> */}
      <div className="container-fluid p-0">
        <div
          id="header-carousel"
          className="carousel slide carousel-fade"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img className="w-100" src={carousel1} alt="Drug addiction and psychological treatment center in Sargodha" />
              <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
                <div className="p-3 text-center" style={{ maxWidth: "900px" }}>
                  <div className="row gx-0">
                    <div className="col-12 d-flex justify-content-center">
                      <img
                        className="animated slideInDown img-fluid text-image"
                        src={azmText}
                        alt="azm-text"
                        style={{ maxWidth: "400px", width: "100%" }}
                      />
                    </div>
                  </div>
                  <h1 className="display-4 display-md-3 display-lg-2 text-white mb-md-4 mt-3 animated zoomIn">
                    Drug Addiction & Psychological
                    <br /> Treatment Centre
                  </h1>
                  <div className="row gx-0 mt-4">
                    <div className="col-12 d-flex justify-content-center">
                      <p className="text-white animated zoomIn center-text fs-5 fs-md-4">
                        علاجگاہ براۓ منشیات و نفسیاتی امراض
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="carousel-item">
              <img className="w-100" src={carousel2} alt="Harm reduction and HIV prevention for drug users" />
              <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
                <div className="p-3 text-center" style={{ maxWidth: "900px" }}>
                  <h5 className="text-white text-uppercase mb-3 animated slideInDown">
                    HARM REDUCTION
                  </h5>
                  <h2 className="display-4 display-md-3 text-white mb-md-4 animated zoomIn">
                    Prevent HIV Among Drug Users
                  </h2>
                </div>
              </div>
            </div>
            <div className="carousel-item">
              <img className="w-100" src={carousel3} alt="Quality drug addiction treatment and recovery care" />
              <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
                <div className="p-3 text-center" style={{ maxWidth: "900px" }}>
                  <h5 className="text-white text-uppercase mb-3 animated slideInDown">
                    Keep Your Health Good
                  </h5>
                  <h2 className="display-4 display-md-3 text-white mb-md-4 animated zoomIn">
                    Take The Best Quality Drug Addiction Treatment
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#header-carousel"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#header-carousel"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>

      {/* <!-- Carousel End --> */}

      {/* <!-- Banner Start --> */}
      <div className="container-fluid banner mb-5">
        <div className="container">
          <div className="row g-3 g-lg-0">
            {/* Opening Hours Section - Responsive */}
            <div className="col-12 col-lg-6 mb-3 mb-lg-0 d-flex">
              <div className="wow zoomIn h-100 w-100" data-wow-delay="0.1s">
                <div
                  className="bg-primary d-flex flex-column p-4 p-md-5 h-100"
                  style={{ minHeight: "300px" }}
                >
                  <div className="d-flex align-items-center mb-3">
                    <div className="appointment-teaser-icon me-3">
                      <i className="far fa-clock"></i>
                    </div>
                    <h3 className="text-white mb-0 fs-4 fs-md-3">Opening Hours</h3>
                  </div>

                  {/* Loading State */}
                  {loading && (
                    <div className="text-center flex-grow-1 d-flex flex-column justify-content-center">
                      <div className="spinner-border text-white" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="text-white mt-2 mb-0 small">Loading opening hours...</p>
                    </div>
                  )}

                  {/* Error State */}
                  {error && (
                    <div className="text-center flex-grow-1 d-flex flex-column justify-content-center">
                      <div className="alert alert-danger bg-transparent border-white text-white p-3" role="alert">
                        <i className="fas fa-exclamation-triangle me-2"></i>
                        <div className="small">{error}</div>
                      </div>
                      <button
                        className="btn btn-light btn-sm mt-2 mx-auto"
                        onClick={() => window.location.reload()}
                        style={{ maxWidth: "120px" }}
                      >
                        <i className="fas fa-redo me-1"></i>
                        Retry
                      </button>
                    </div>
                  )}

                  {/* No Data State */}
                  {!loading && !error && openingHours.length === 0 && (
                    <div className="text-center flex-grow-1 d-flex flex-column justify-content-center">
                      <div className="alert alert-warning bg-transparent border-white text-white p-3" role="alert">
                        <i className="fas fa-info-circle me-2"></i>
                        <div className="small">No opening hours available.</div>
                      </div>
                    </div>
                  )}

                  {/* Hours Display */}
                  {!loading && !error && openingHours.length > 0 && (
                    <div className="opening-hours-list flex-grow-1" style={{ overflowY: "auto" }}>
                      {groupOpeningHours(openingHours).map((group, index) => (
                        <div
                          key={index}
                          className="d-flex justify-content-between align-items-start text-white mb-3 py-2 border-bottom border-light border-opacity-25 flex-wrap"
                        >
                          <div className="me-2 mb-1 mb-md-0">
                            <h6 className="text-white mb-0 fw-bold small">
                              {group.days}:
                            </h6>
                          </div>
                          <div className="text-end">
                            <div>
                              {group.is_closed ? (
                                <span className="badge bg-danger small">
                                  <i className="fas fa-times me-1"></i>
                                  {group.emergency_only ? 'Emergency Only' : 'Closed'}
                                </span>
                              ) : (
                                <span className="badge bg-success small">
                                  <i className="fas fa-clock me-1"></i>
                                  {group.time}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}

                      {/* Emergency note - Responsive */}
                      <div className="d-flex justify-content-between align-items-center text-white py-2 mt-3 bg-dark bg-opacity-25 px-3 rounded flex-wrap">
                        <div className="me-2 mb-1 mb-md-0">
                          <h6 className="text-white mb-0 small">
                            <i className="fas fa-ambulance me-2 text-danger"></i>
                            Emergency Services
                          </h6>
                        </div>
                        <div className="text-end">
                          <small className="badge bg-warning text-dark">
                            24/7 Available
                          </small>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Make Appointment Section - Responsive */}
            <div className="col-12 col-lg-6 d-flex">
              <div className="wow zoomIn h-100 w-100" data-wow-delay="0.6s">
                <div
                  className="appointment-teaser d-flex flex-column p-4 p-md-5 h-100"
                  style={{ minHeight: "300px" }}
                >
                  <div className="d-flex align-items-center mb-3">
                    <div className="appointment-teaser-icon me-3">
                      <i className="fas fa-calendar-check"></i>
                    </div>
                    <h3 className="text-white mb-0 fs-4 fs-md-3">Make Appointment</h3>
                  </div>
                  <p className="text-white mb-4 flex-grow-1">
                    Ready to start your journey to recovery? <br className="d-none d-md-block" />
                    Contact us to schedule your appointment today.
                  </p>
                  <div className="d-flex flex-wrap align-items-center gap-3">
                    <a href="tel:+923009605574" className="btn btn-light btn-lg fw-bold px-4">
                      <i className="fas fa-phone-alt me-2"></i>03009605574
                    </a>
                    <button
                      type="button"
                      className="btn btn-outline-light btn-lg px-4"
                      onClick={() =>
                        document
                          .getElementById("appointment-form")
                          ?.scrollIntoView({ behavior: "smooth" })
                      }
                    >
                      Book Online
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Banner End --> */}

      {/* <!-- About Start --> */}
      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container">
          <div className="row g-4 g-lg-5">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="section-title mb-4">
                <h5 className="position-relative d-inline-block text-primary text-uppercase">
                  About Azm Rehab Centre
                </h5>
                <h2 className="display-6 display-md-5 mb-0">
                  Sargodha's Trusted Drug Addiction & Rehabilitation Treatment Center
                </h2>
              </div>
              <h4 className="text-body mb-4 fs-5 fs-md-4">
                ہماری مخصوص ٹیم آپ کو ذاتی علاج فراہم کرتی ہے، جو برسوں کی کامیابی سے ثابت ہے۔ آئیے ہم آپ کی زندگی واپس دلانے میں مدد کریں۔
              </h4>
              <p className="mb-4">
                As a leading drug addiction and rehabilitation treatment center
                in Sargodha, every step of your recovery journey is guided by
                our certified professionals, ensuring you receive the highest
                standard of nasha treatment and psychological care. Trust us
                to help you take the first step towards a healthier, happier
                life.
              </p>
              <div className="row g-3">
                <div className="col-sm-6 mb-3">
                  <h6 className="mb-0 fs-6">
                    <i className="fa fa-check-circle text-primary me-3"></i>
                    Award Winning
                  </h6>
                </div>
                <div className="col-sm-6 mb-3">
                  <h6 className="mb-0 fs-6">
                    <i className="fa fa-check-circle text-primary me-3"></i>
                    Professional Staff
                  </h6>
                </div>
                <div className="col-sm-6 mb-3">
                  <h6 className="mb-0 fs-6">
                    <i className="fa fa-check-circle text-primary me-3"></i>24/7
                    Opened
                  </h6>
                </div>
                <div className="col-sm-6 mb-3">
                  <h6 className="mb-0">
                    <i className="fa fa-check-circle text-primary me-3"></i>Fair
                    Prices
                  </h6>
                </div>
              </div>
            </div>
            <div
              className="col-lg-6 d-flex justify-content-center align-items-center"
            >
              <div>
                <img
                  className="img-fluid rounded"
                  src={bannerImg}
                  alt="Azm Rehab Centre addiction treatment facility"
                  style={{ objectFit: "cover", maxWidth: "100%" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- About End --> */}

      <Appointment />

      {/* <!-- Team Start --> */}
      <div className="container-fluid py-5">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-4 wow slideInUp" data-wow-delay="0.1s">
              <div className="section-title bg-light rounded h-100 p-5">
                <h5 className="position-relative d-inline-block text-primary text-uppercase">
                  Our Doctors
                </h5>
                <h2 className="display-6 mb-4">
                  Meet Our Certified and Highly Experienced Doctors
                </h2>
                {/* <a href="appointment.html" className="btn btn-primary py-3 px-5">Appointment</a> */}
              </div>
            </div>
            {doctors.map((doctor, index) => (
              <div
                key={index}
                className="col-lg-4 wow slideInUp"
                data-wow-delay={`${0.3 + index * 0.2}s`}
              >
                <div className="team-item">
                  <div
                    className="position-relative rounded-top"
                    style={{ zIndex: "1" }}
                  >
                    <img
                      className="img-fluid rounded-top w-100"
                      src={getImageSource(doctor)}
                      alt={doctor.name}
                    />
                  </div>
                  <div className="team-text position-relative bg-light text-center rounded-bottom p-4 pt-5">
                    <p className="text-blue mb-0">{doctor.designation}</p>
                    <h4 className="mb-2">{doctor.name}</h4>
                    <span>{doctor.degrees}</span>
                    {doctor.specialization?.split(',').map((item, i) => (
                      <p key={i} className="text-primary mb-0">
                        {item.trim()}
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            ))}


            {/* <div className="col-lg-4 wow slideInUp" data-wow-delay="0.1s">
                    <div className="team-item">
                        <div className="position-relative rounded-top" style={{zIndex: "1"}}>
                            <img className="img-fluid rounded-top w-100" src={team3} alt=""/>
                            // <div className="position-absolute top-100 start-50 translate-middle bg-light rounded p-2 d-flex">
                            //     <a className="btn btn-primary btn-square m-1" href="#"><i className="fab fa-twitter fw-normal"></i></a>
                            //     <a className="btn btn-primary btn-square m-1" href="#"><i className="fab fa-facebook-f fw-normal"></i></a>
                            //     <a className="btn btn-primary btn-square m-1" href="#"><i className="fab fa-linkedin-in fw-normal"></i></a>
                            //     <a className="btn btn-primary btn-square m-1" href="#"><i className="fab fa-instagram fw-normal"></i></a>
                            // </div>
                        </div>
                        <div className="team-text position-relative bg-light text-center rounded-bottom p-4 pt-5">
                            <h4 className="mb-2">Dr. John Doe</h4>
                            <p className="text-primary mb-0">Implant Surgeon</p>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 wow slideInUp" data-wow-delay="0.3s">
                    <div className="team-item">
                        <div className="position-relative rounded-top" style={{zIndex: "1"}}>
                            <img className="img-fluid rounded-top w-100" src={team4} alt=""/>
                            // <div className="position-absolute top-100 start-50 translate-middle bg-light rounded p-2 d-flex">
                            //     <a className="btn btn-primary btn-square m-1" href="#"><i className="fab fa-twitter fw-normal"></i></a>
                            //     <a className="btn btn-primary btn-square m-1" href="#"><i className="fab fa-facebook-f fw-normal"></i></a>
                            //     <a className="btn btn-primary btn-square m-1" href="#"><i className="fab fa-linkedin-in fw-normal"></i></a>
                            //     <a className="btn btn-primary btn-square m-1" href="#"><i className="fab fa-instagram fw-normal"></i></a>
                            // </div>
                        </div>
                        <div className="team-text position-relative bg-light text-center rounded-bottom p-4 pt-5">
                            <h4 className="mb-2">Dr. John Doe</h4>
                            <p className="text-primary mb-0">Implant Surgeon</p>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 wow slideInUp" data-wow-delay="0.6s">
                    <div className="team-item">
                        <div className="position-relative rounded-top" style={{zIndex: "1"}}>
                            <img className="img-fluid rounded-top w-100" src={team5} alt=""/>
                            // <div className="position-absolute top-100 start-50 translate-middle bg-light rounded p-2 d-flex">
                            //     <a className="btn btn-primary btn-square m-1" href="#"><i className="fab fa-twitter fw-normal"></i></a>
                            //     <a className="btn btn-primary btn-square m-1" href="#"><i className="fab fa-facebook-f fw-normal"></i></a>
                            //     <a className="btn btn-primary btn-square m-1" href="#"><i className="fab fa-linkedin-in fw-normal"></i></a>
                            //     <a className="btn btn-primary btn-square m-1" href="#"><i className="fab fa-instagram fw-normal"></i></a>
                            // </div>
                        </div>
                        <div className="team-text position-relative bg-light text-center rounded-bottom p-4 pt-5">
                            <h4 className="mb-2">Dr. John Doe</h4>
                            <p className="text-primary mb-0">Implant Surgeon</p>
                        </div>
                    </div>
                </div> */}
          </div>
        </div>
      </div>
      {/* <!-- Team End --> */}

      {/* <!-- Newsletter Start --> */}
      <div
        className="container-fluid position-relative pt-5 wow fadeInUp"
        data-wow-delay="0.1s"
        style={{ zIndex: "1" }}
      >
        <ToastContainer />
        <div className="container">
          <div className="bg-primary p-5">
            <form
              className="mx-auto"
              style={{ maxWidth: "600px" }}
              onSubmit={handleSubmit}
            >
              <div className="form-floating mb-4">
                <input
                  type="text"
                  id="email"
                  name="email"
                  className={`form-control ${touched.email && errors.email ? "is-invalid" : ""
                    }`}
                  placeholder="Your Email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <label htmlFor="email">Email</label>
                {touched.email && errors.email && (
                  <div className="invalid-feedback">{errors.email}</div>
                )}
              </div>
              <button
                type="submit"
                className="btn btn-dark px-4"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Subscribing..." : "Subscribe"}
              </button>
            </form>
          </div>
        </div>
      </div>
      {/* <!-- Newsletter End --> */}

      <Footer />
    </>
  );
}
